import { useMemo, useCallback } from "react";
import { useI18nContext, useI18nCountry } from "@hopper-b2b/i18n";
import emojiFlags from "emoji-flags";

interface EmojiFlagProps {
  countryCode: string;
}

const EmojiFlag: React.FC<EmojiFlagProps> = ({ countryCode }) => (
  <span className="checkout-country-option-flag-icon">
    {emojiFlags.countryCode(countryCode).emoji}
  </span>
);

export const useCountryOptions = (showPreferredCountry = true) => {
  const { t, brand } = useI18nContext();
  const { getAllCountryNames } = useI18nCountry();

  const countryOptions = useMemo(
    () =>
      Array.from(Object.entries(getAllCountryNames()))
        .map(([code, label]) => {
          return {
            label,
            value: code,
            icon: <EmojiFlag countryCode={code} />,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label)),
    [getAllCountryNames]
  );

  const getNationalityOptions = useCallback(
    (preferredCountry: string) => [
      ...countryOptions.filter((option) => option.value === preferredCountry),
      ...countryOptions.filter((option) => option.value !== preferredCountry),
    ],
    [countryOptions]
  );

  if (!showPreferredCountry) return countryOptions;

  return getNationalityOptions(brand?.preferredCountryCode || "");
};
